/* unplugin-vue-components disabled */import script from "./our-cases.vue?vue&type=script&setup=true&lang=js"
export * from "./our-cases.vue?vue&type=script&setup=true&lang=js"

import "./our-cases.vue?vue&type=style&index=0&id=19cdd313&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.12_vue@3.5.12_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19cdd313"]])

export default __exports__